import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useGetPriceInUserCurrencyPerSelectedAmenity() {
    const {
        singleRouteAmenities,
        returnRouteAmenities,
    } = useAppSelector((state) => (state.checkOrder.ticket.amenities))

    /**
     * In all the single amenities find the one with matching key, and return its price in user's currency
     */
    const getPriceInUserCurrencyPerSelectedSingleAmenity = (key: string, direction: "single" | "return"): number => {
        const allAmenitiesArray = (direction === "single" ? singleRouteAmenities : returnRouteAmenities).map(
            (amenityGroup) => (
                amenityGroup.amenities
            )
        ).flat(1)

        return allAmenitiesArray.filter((amenity) => (amenity.key === key))[0].priceInUserCurrency
    }

    return {
        getPriceInUserCurrencyPerSelectedSingleAmenity,
    }
}